import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { status } from 'constants/general';
import companyActivationStrings from 'modules/companyActivation/strings';
import CompanyActivationHeader from 'modules/companyActivation/components/CompanyActivationHeader';
import CompanyActivationFilter from 'modules/companyActivation/components/CompanyActivationFilter';
import CompanyActivationList from 'modules/companyActivation/components/CompanyActivationList';
import Loader from 'modules/common/components/Loader';
import Pagination from 'modules/common/components/Pagination';
import Popup from 'modules/common/components/Popup';

import {
  CompanyWrapper,
  LoaderWrapper,
  NoResultsWrapper,
  NoResultsText,
  PaginationWrapper,
  ImgPreview,
  ToastTextOverlay,
} from './CompanyActivationComponent.style';

const CompanyActivationComponent = ({
  showCopiedTextOverlay,
  selectedStatusFilter,
  searchQuery,
  selectedPageFilter,
  isPreviewFilePopupOpen,
  previewFileUrl,
  isActionPopupOpen,
  isActionPopupLoading,
  actionPopupStatus,
  handleTextToCopyToClipboardClick,
  handleCompanyStatusFilterClick,
  handleSearchBarInputChange,
  handleCompanyPaginationClick,
  handlePreviewFileClick,
  handleActionBtnClick,
  handleActionPopupConfirmBtnClick,
  handleActionPopupDismissBtnClick,
}) => {
  const { staticData, companyActivationList } = useSelector(state => ({
    staticData: state.common.staticData,
    companyActivationList: state.companyActivation.companyActivationList,
  }));

  const totalResultsCount = companyActivationList?.details?.totalCount;
  const numberOfPages = (totalResultsCount && Math.ceil(totalResultsCount / 10)) || 1;
  const companyActivationListArr = companyActivationList?.details?.results;

  const renderCompanyActivationList = () => {
    if (
      companyActivationList.status === status.SHOULD_CALL_API ||
      companyActivationList.status === status.FETCHING ||
      staticData.status === status.SHOULD_CALL_API ||
      staticData.status === status.FETCHING
    )
      return (
        <LoaderWrapper>
          <Loader />
        </LoaderWrapper>
      );

    if (companyActivationList.status === status.SUCCESS && companyActivationListArr?.length > 0)
      return (
        <>
          <CompanyActivationList
            companyActivationListArr={companyActivationListArr}
            isActionPopupOpen={isActionPopupOpen}
            isActionPopupLoading={isActionPopupLoading}
            actionPopupStatus={actionPopupStatus}
            handleTextToCopyToClipboardClick={handleTextToCopyToClipboardClick}
            handlePreviewFileClick={handlePreviewFileClick}
            handleActionBtnClick={handleActionBtnClick}
            handleActionPopupConfirmBtnClick={handleActionPopupConfirmBtnClick}
            handleActionPopupDismissBtnClick={handleActionPopupDismissBtnClick}
          />
          {numberOfPages > 1 && (
            <PaginationWrapper>
              <Pagination
                currentPage={selectedPageFilter}
                totalCount={numberOfPages}
                handlePaginationClick={handleCompanyPaginationClick}
              />
            </PaginationWrapper>
          )}
          {isPreviewFilePopupOpen && (
            <Popup handleCloseBtnClick={() => handlePreviewFileClick(false)}>
              <ImgPreview src={previewFileUrl} />
            </Popup>
          )}
          {showCopiedTextOverlay && (
            <ToastTextOverlay>
              {companyActivationStrings.companyActivationList.copiedToClipboardText}
            </ToastTextOverlay>
          )}
        </>
      );

    return (
      <NoResultsWrapper>
        <NoResultsText>
          {companyActivationStrings.companyActivationList.companyActivationGridNoResultsFound}
        </NoResultsText>
      </NoResultsWrapper>
    );
  };

  return (
    <>
      <CompanyActivationHeader
        selectedStatusFilter={selectedStatusFilter}
        handleCompanyStatusFilterClick={handleCompanyStatusFilterClick}
      />
      <CompanyWrapper>
        <CompanyActivationFilter
          searchQuery={searchQuery}
          handleSearchBarInputChange={handleSearchBarInputChange}
        />
        {renderCompanyActivationList()}
      </CompanyWrapper>
    </>
  );
};

CompanyActivationComponent.propTypes = {
  showCopiedTextOverlay: PropTypes.bool.isRequired,
  selectedStatusFilter: PropTypes.number.isRequired,
  searchQuery: PropTypes.string.isRequired,
  selectedPageFilter: PropTypes.number.isRequired,
  isPreviewFilePopupOpen: PropTypes.bool.isRequired,
  previewFileUrl: PropTypes.string.isRequired,
  isActionPopupOpen: PropTypes.bool.isRequired,
  isActionPopupLoading: PropTypes.bool.isRequired,
  actionPopupStatus: PropTypes.string.isRequired,
  handleTextToCopyToClipboardClick: PropTypes.func.isRequired,
  handleCompanyStatusFilterClick: PropTypes.func.isRequired,
  handleSearchBarInputChange: PropTypes.func.isRequired,
  handleCompanyPaginationClick: PropTypes.func.isRequired,
  handlePreviewFileClick: PropTypes.func.isRequired,
  handleActionBtnClick: PropTypes.func.isRequired,
  handleActionPopupConfirmBtnClick: PropTypes.func.isRequired,
  handleActionPopupDismissBtnClick: PropTypes.func.isRequired,
};

export default CompanyActivationComponent;
